<template>
    <bsp-tabs :tabList="tabList" :tabIndex="tabIndex" @changeTab="changeTab">
      <component  :is="currentTab" :currentTab='currentTab'></component>
    </bsp-tabs>
</template>
<script>
  import bspTabs from "@/components/bsp/bsp-tabs/bsp-tabs";
  import billList from "@/views/wage/pay-notice/pay-notice-list";
  export default {
    data() {
      return {
        tabList: [{
          title: '在途',
          name: 'exe',
        }, {
          title: '历史',
          name: 'his',
        }],
        tabIndex: sessionStorage.getItem("tabIndex")?sessionStorage.getItem("tabIndex"):'exe',
        currentTab:sessionStorage.getItem("tabIndex")?sessionStorage.getItem("tabIndex"):'exe',
      }
    },
    components:{
      bspTabs,
      exe: billList,
      his: billList,
    },
    created(){
    },
    methods: {
      changeTab(tab, event) {
        this.currentTab = tab.name;
        sessionStorage.setItem("tabIndex",tab.name);
      }
    }
  }
</script>
